import React from 'react';
import { Card, FormH1, LoadingHeaderBar, LoadingButton, FormH2, LoadingDescriptionBar } from './AccountElements';

const AccountLoading = () => {
    return (
        <Card>
            <FormH1>Account Details</FormH1>
            <FormH2>Fetching your account details</FormH2>
            <LoadingHeaderBar />
            <LoadingDescriptionBar />
            <LoadingButton />
        </Card>
    );
};

export default AccountLoading;
